const mapping = [
  { from: "data.attributes.description", to: "description" },
  { from: "data.attributes.value", to: "value" },
];

export default mapping;
